import { api } from 'shared';

export const createLead = async (name: string, phone: string, comment?: string) => (
    api.post(
        '/leads',
        {
            data: {
                name,
                phone,
                comment,
            },
        },
        {},
    )
);
